import MyRegisterShipment from './myRegisterShipment';

export default MyRegisterShipment;
